import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { getElementId, getReactions } from '../../../common/elements/utils/elementPropertyUtils';
import { length } from '../../../common/utils/immutableHelper';
import { getCurrentUserId } from '../../user/currentUserSelector';
import { getGridSize } from '../../utils/grid/gridSizeSelector';

import { getReactionUserId, getReactionEmojiCode } from './reactionUtil';

import { updateReaction } from './reactionActions';

import { canWrite, canGiveFeedback } from '../../../common/permissions/permissionUtil';

import ElementReactionPill from './ElementReactionPill';
import ElementReactionAddButton from './ElementReactionAddButton';

import './ElementReactions.scss';

const mapStateToProps = createStructuredSelector({
    gridSize: getGridSize,
    currentUserId: getCurrentUserId,
});

const mapDispatchToProps = (dispatch) => ({
    toggleReaction: ({ elementIds, emojiCode }) =>
        dispatch(
            updateReaction({
                updateIds: elementIds,
                emojiCode,
            }),
        ),
});

const ElementReactionList = ({
    element,
    elementId: _elementId,
    reactions: _reactions,
    currentUserId,
    gridSize,
    toggleReaction,
    permissions,
}) => {
    const elementId = _elementId || getElementId(element);
    const reactions = _reactions || getReactions(element) || [];
    const reactionCount = length(reactions);

    if (!reactionCount) return null;

    const userCanWriteReactions = canWrite(permissions) || canGiveFeedback(permissions);

    const uniqueReactions = reactions.reduce((acc, reaction) => {
        const userId = getReactionUserId(reaction);
        const emojiCode = getReactionEmojiCode(reaction);

        const reactionGroup = acc[emojiCode] || { emojiCode, userIds: [] };
        reactionGroup.userIds.push(userId);

        acc[emojiCode] = reactionGroup;

        return acc;
    }, {});

    const uniqueReactionsList = Object.values(uniqueReactions);

    const toggleReactionForEmoji = (emojiCode) =>
        toggleReaction({
            elementIds: [elementId],
            emojiCode,
        });

    return (
        <div className="ElementReactions">
            {uniqueReactionsList.map(({ emojiCode, userIds }) => (
                <ElementReactionPill
                    key={emojiCode}
                    disabled={!userCanWriteReactions}
                    emojiCode={emojiCode}
                    userIds={userIds}
                    currentUserId={currentUserId}
                    gridSize={gridSize}
                    toggleReaction={toggleReactionForEmoji}
                />
            ))}

            {userCanWriteReactions && <ElementReactionAddButton elementId={elementId} />}
        </div>
    );
};

ElementReactionList.propTypes = {
    currentUserId: PropTypes.string,
    elementId: PropTypes.string,
    permissions: PropTypes.number,
    gridSize: PropTypes.number,
    reactions: PropTypes.object,
    element: PropTypes.object,
    toggleReaction: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(ElementReactionList);
